import { HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from '@siren-survey/app/services/shared/base-service';
import { MyHttpHandler } from '@siren-survey/app/services/shared/http-handler.service';
import { Observable } from 'rxjs';
import { Achievement } from 'src/app/models/admin/program/achievement/achievement';

@Injectable({
  providedIn: 'root'
})
export class AchievementService extends BaseService<Achievement, Achievement> {

  constructor(http: MyHttpHandler, protected injector: Injector){
    super("/v1/achievement", http, injector);
  }

  checkAchievementUnicity(achievement: Achievement): Observable<HttpResponse<Boolean>> {
    return this.http.post<Boolean>("/v1/achievement/achievement-valid", achievement);
  }
}
